import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Dropdown } from "semantic-ui-react";

class SemesterSelector extends Component {
  constructor(props) {
    super(props);
    // Default semester options
    this.semesterOptions = [
      { key: "1", value: "1", text: "1st Semester" },
      { key: "2", value: "2", text: "2nd Semester" },
      { key: "summer", value: "summer", text: "Summer" },
    ];
  }

  // Helper method to ensure user's current semester is in options
  getEnhancedOptions = () => {
    const { value } = this.props;
    const options = this.semesterOptions;
    if (!value) return options;
    // Check if current value exists in options
    const existingOption = options.find((opt) => opt.value === value);
    if (!existingOption && value) {
      // Add user's current semester to options if not found
      return [
        ...options,
        {
          key: `current-${value}`,
          value: value,
          text: value,
        },
      ];
    }
    return options;
  };

  render() {
    const {
      value,
      onChange,
      required,
      placeholder,
      label,
      name,
      disabled,
      options,
    } = this.props;
    // Use provided options or enhanced default options
    const dropdownOptions = options || this.getEnhancedOptions();
    return (
      <Form.Field required={required}>
        {label && <label>{label}</label>}
        <Dropdown
          placeholder={placeholder}
          fluid
          selection
          name={name}
          value={value}
          options={dropdownOptions}
          onChange={onChange}
          disabled={disabled}
          className="semester-selector"
        />
      </Form.Field>
    );
  }
}

SemesterSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.array,
};

SemesterSelector.defaultProps = {
  value: "",
  required: false,
  placeholder: "Select Semester",
  label: "Semester",
  disabled: false,
  options: null,
};

export default SemesterSelector;
